// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__S+0l3","social_list":"Footer_social_list__qG7wY","copyright":"Footer_copyright__aqJkK"};